import { gql } from "@apollo/client";

export const AddFilesToInstalledBaseNode = gql`
    mutation AddFilesToInstalledBaseNode ($installedBaseNodeId: ID!, $input: [InstalledBaseNodeFileCreateAttributesInput!]){
        addFilesToInstalledBaseNode(installedBaseNodeId: $installedBaseNodeId, input: $input){
            id
        }
    }
`;
